import { Link } from 'react-router-dom';

export default function Ecosystem() {
  const components = [
    {
      title: 'PepChain',
      subtitle: 'Blockchain Layer',
      description: 'Lightning-fast blockchain that processes 100,000 transactions per second with near-zero fees. Built for speed, designed for scale, optimized for the future.',
      features: ['Smart Contracts', 'Block Explorer', 'Cross-Chain Bridge', 'Gas Optimization'],
      icon: 'ri-links-fill',
      image: 'futuristic+blockchain+network+visualization+with+glowing+interconnected+nodes+and+data+blocks+flowing+through+digital+pathways+dark+background+with+cyan+and+purple+neon+lights+high+tech+distributed+ledger+concept+professional+3D+rendering',
    },
    {
      title: 'PepCoin Token',
      subtitle: 'PEP Utility Token',
      description: 'The heartbeat of our ecosystem – stake for up to 15% APR, vote on governance, unlock exclusive NFTs, and watch your holdings grow with our deflationary auto-burn model.',
      features: ['Trading & Staking', 'Governance Voting', 'NFT Access', 'Reward Distribution'],
      icon: 'ri-coin-fill',
      image: 'golden+cryptocurrency+coin+with+glowing+PEP+symbol+floating+in+digital+space+surrounded+by+holographic+data+streams+and+blockchain+particles+dark+background+with+cyan+and+gold+lighting+premium+crypto+token+visualization+professional+3D+render',
    },
    {
      title: 'PepBot',
      subtitle: 'AI Trading Engine',
      description: 'Your personal Wall Street analyst powered by neural networks – analyzes millions of data points, predicts market movements, and executes trades with 94% accuracy.',
      features: ['AI Predictions', 'Auto-Trading', 'Risk Management', 'Performance Analytics'],
      icon: 'ri-robot-2-fill',
      image: 'advanced+AI+robot+assistant+analyzing+cryptocurrency+trading+charts+and+market+data+on+holographic+displays+futuristic+command+center+with+glowing+screens+dark+environment+with+cyan+and+blue+neon+accents+professional+fintech+visualization',
    },
  ];

  return (
    <section className="py-32 px-6 relative overflow-hidden bg-gradient-to-b from-black via-gray-950 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Platform Architecture & Technical Components
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Integrated blockchain infrastructure designed for secure, transparent, and compliant decentralized financial operations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            {
              icon: 'ri-exchange-line',
              title: 'Decentralized Exchange',
              description: 'Non-custodial trading protocol with automated market making. Smart contract-based order execution.',
              gradient: 'from-blue-500 to-cyan-500'
            },
            {
              icon: 'ri-wallet-3-line',
              title: 'Multi-Signature Wallets',
              description: 'Hierarchical deterministic wallet infrastructure with multi-party authorization requirements.',
              gradient: 'from-purple-500 to-pink-500'
            },
            {
              icon: 'ri-safe-2-line',
              title: 'Staking Infrastructure',
              description: 'Proof-of-stake validation system with time-locked deposits and variable reward distribution.',
              gradient: 'from-emerald-500 to-teal-500'
            },
            {
              icon: 'ri-shield-check-line',
              title: 'Security Monitoring',
              description: 'Real-time transaction analysis, anomaly detection, and automated threat response systems.',
              gradient: 'from-orange-500 to-red-500'
            },
            {
              icon: 'ri-file-shield-2-line',
              title: 'Compliance Engine',
              description: 'Automated KYC/AML verification, transaction screening, and regulatory reporting infrastructure.',
              gradient: 'from-indigo-500 to-purple-500'
            },
            {
              icon: 'ri-database-2-line',
              title: 'Blockchain Explorer',
              description: 'Public transaction verification interface with complete audit trail and data transparency.',
              gradient: 'from-pink-500 to-rose-500'
            },
            {
              icon: 'ri-line-chart-line',
              title: 'Risk Analytics Engine',
              description: 'Portfolio risk assessment, volatility tracking, and exposure monitoring with real-time alerts.',
              gradient: 'from-cyan-500 to-blue-500'
            },
            {
              icon: 'ri-code-s-slash-line',
              title: 'API Infrastructure',
              description: 'RESTful and WebSocket APIs for verified institutional partners with rate limiting and authentication.',
              gradient: 'from-teal-500 to-emerald-500'
            }
          ].map((component, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300">
              <div className={`w-14 h-14 bg-gradient-to-br ${component.gradient} rounded-xl flex items-center justify-center mb-4`}>
                <i className={`${component.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{component.title}</h3>
              <p className="text-white/70 text-sm leading-relaxed">{component.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
          <div className="flex items-start gap-3">
            <i className="ri-information-line text-white/80 text-xl mt-0.5"></i>
            <div>
              <p className="text-white font-semibold mb-1">Technical Infrastructure Notice</p>
              <p className="text-white/80 text-sm">
                All components subject to ongoing development, security updates, and potential service interruptions. Smart contract code available for independent audit. No system is completely secure or immune to vulnerabilities.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
